<div>
	<canvas baseChart [datasets]="stages.data" [labels]="stages.labels" [colors]="chartColors" [options]="chartOptions" chartType="bar" *ngIf="isReady"></canvas>
</div>
